import { get, post } from './../utils/api';
import { DataResponse } from './response';
export type CommonDate = {
  fromDate: string;
  toDate: string;
};

export type ListDate = {
  key: string;
  value: string;
};
export type ProductResponse = {
  data: Array<ListDate>;
  message: string;
  isSuccess: boolean;
  [key: string]: any;
};

export type ListStatusProduct = {
  key: string;
  value: string;
};

export type ListStatusProductResponse = {
  data: Array<ListStatusProduct>;
  message: string;
  isSuccess: boolean;
};
// công đoạn sản xuất
export interface DropdownRouting {
  stepCode: string;
  stepName: string;
  orderIndex: number;
}
// Interface dropdown equipment
export interface DropdownEquipment {
  key: string;
  value: string;
  equipmentProduction: number;
  unit: string;
}

export type ListDropdownEquipmentResponse = {
  data: Array<DropdownEquipment>;
  message: string;
  isSuccess: boolean;
};
export interface ICommonDateServices {
  getDataByCommonDate(date?: string): Promise<CommonDate>;
  getListCommonDate(type?: string): Promise<ProductResponse>;
  getListStatusProduct(): Promise<ListStatusProductResponse>;
  // danh sách dropdown thành phẩm / bán thành phẩm */
  getListDropdownProduct(productCode: string, type?: string): Promise<ListStatusProductResponse>;
  // lấy danh sách dropdown bằng từ khóa
  getDropdownByKeyword(keyword: string): Promise<ListStatusProductResponse>;
  // Lấy danh sách bin
  getDropdownBin(keyword: string): Promise<ListStatusProductResponse>;
  // Lấy danh sách current bin
  getDropdownCurrentBin(keyword: string): Promise<ListStatusProductResponse>;
  // lấy danh sách dropdown công đoạn
  getDropdownRouting(keyword?: string): Promise<DataResponse<Array<DropdownRouting>>>;
  // lấy danh sách dropdown lệnh sản xuất
  getDropdownWo(woCode: string): Promise<DataResponse<Array<ListStatusProduct>>>;

  // getDropdown MoldTestResult
  getDropdownMoldTestResult(keyWord: string): Promise<ListStatusProductResponse>;

  // lấy dropdown nhân viên
  getDropdownSaleEmployee(keyWord: string, toSX?: string[], actived?: boolean): Promise<ListStatusProductResponse>;

  // lấy dropdown equipment
  getDropdownEquipment(keyWord: string): Promise<ListDropdownEquipmentResponse>;

  // Lấy trạng thái máy móc
  getStatusEquipByID(id: string): Promise<string>;

  // Danh sách máy móc
  getListDropdownEquipmentV2(key?: string): Promise<ListDropdownEquipmentResponse>;
  // Danh sách khách hàng
  getListCustomer(key?: string): Promise<ListStatusProductResponse>;
  // Phân cấp sản phẩm
  getListPhanCapSP(key?: string): Promise<DataResponse<Array<ListStatusProduct>>>;

  // load tất cả khuôn
  getAllMolds(): Promise<DataResponse<Array<ListStatusProduct>>>;
}

export function createCommonDateServices(): ICommonDateServices {
  return {
    getDataByCommonDate: async (date?: string): Promise<CommonDate> => {
      return (await get(`Utilities/CommonDate/GetDateByCommonDate?CommonDate=${date}`)).data;
    },
    // type = Future là lấy danh sách dự kiến
    getListCommonDate: async (type?: string): Promise<ProductResponse> => {
      return (await get(`Utilities/CommonDate/get-common-date${type ? '?Type=' + type : ''}`)).data;
    },
    getListStatusProduct: async (): Promise<ListStatusProductResponse> => {
      return (await get(`MasterData/Common/list-status-product`)).data;
    },
    getListDropdownProduct: async (productCode: string, type?: string) => {
      return (
        await get(
          `MasterData/Common/list-dropdown-product`, {
          ProductCode: productCode || undefined,
          type: type || undefined
        }
        )
      ).data;
    },
    getDropdownByKeyword: async (keyword: string) => {
      return (await get(`MasterData/Common/get-dropdown?keyWord=${keyword}`)).data;
    },
    // Lấy danh sách bin
    getDropdownBin: async (keyword: string) => {
      return (await get(`MasterData/Common/get-dropdown-bin${keyword === '' ? '' : '?keyWord=' + keyword}`)).data;
    },
    // Lấy danh sách currentbin
    getDropdownCurrentBin: async (keyword: string) => {
      return (await get(`MasterData/Common/get-dropdown-current-bin${keyword === '' ? '' : '?keyWord=' + keyword}`))
        .data;
    },
    // dropdown routing
    getDropdownRouting: async (keyword: string) => {
      return (await get(`MasterData/Common/GetDropDownRoutingList${keyword ? '?KeyWord=' + keyword : ''}`)).data;
    },
    getDropdownWo: async (woCode: string) => {
      return (await get(`MasterData/Common/get-dropdown-wo${woCode !== '' ? '?keyWord=' + woCode : ''}`)).data;
    },

    // getDropdown MoldTestResult
    getDropdownMoldTestResult: async (keyWord: string) => {
      return (await get(`MasterData/Common/get-dropdown?${keyWord ? `keyWord=${keyWord}` : ''}`)).data;
    },
    // lấy dropdown nhân viên
    getDropdownSaleEmployee: async (keyWord: string, toSX, actived) => {
      return (
        await post(
          `MasterData/Common/list-dropdown-sale-employee${keyWord ? `?keyWord=${keyWord}` : ''}${actived !== undefined ? '?actived=' + actived : ''
          }`,
          toSX,
        )
      ).data;
    },
    // Lấy dropdown equipment
    getDropdownEquipment: async (keyWord: string) => {
      return (await get(`MasterData/Common/list-dropdown-equipment${keyWord ? `?keyWord=${keyWord}` : ''}`)).data;
    },
    // Lấy dropdown equipment

    // Lấy trạng thái máy móc
    getStatusEquipByID: async (id) => {
      return (await get(`MasterData/Common/get-status-equip/${id}`)).data.data;
    },
    // Danh sách máy móc
    getListDropdownEquipmentV2: async (key) => {
      return (await get(`MasterData/Common/list-dropdown-equipment-v2${key ? `?keyword=${key}` : ''}`)).data;
    },
    // Danh sách KH
    getListCustomer: async (key) => {
      return (await get(`MasterData/Common/list-customer${key ? `?keyword=${key}` : ''}`)).data;
    },
    // Phân cấp sản phẩm
    getListPhanCapSP: async (key) => {
      return (await get(`MasterData/Common/list-pcsp${key ? `?keyword=${key}` : ''}`)).data;
    },
    // load tất cả khuôn
    getAllMolds: async () => {
      return (await get(`MasterData/Common/list-mold-all`)).data;
    },

  };
}
